import React from 'react';
import { CtaButton } from './CtaButton';
import { TrustStrip } from './TrustStrip';
import { CroppedImage } from './CroppedImage';
import { PURCHASE_MOCKUP, MID_CLOSING, MID_TITLE_1, MID_TITLE_2, midHighlights, pricing } from '../data/resinContent';
export function MidPageCta() {
  return <section className="w-full border-y border-champagne/25 bg-charcoal-950 py-12 sm:py-16" aria-labelledby="mid-cta-title" data-id="element-197" data-mp="8iy7uqfajbao">
      <div className="mx-auto grid max-w-5xl items-center gap-8 px-5 text-center lg:grid-cols-2 lg:gap-12 lg:text-left" data-id="element-198" data-mp="37z4vj7uykpaa">
        <div data-id="element-199" data-mp="3c1hsb6rq9cux">
          <h2 id="mid-cta-title" className="font-display text-[1.55rem] font-semibold uppercase leading-tight text-ivory-50 sm:text-[2.1rem]" data-id="element-200" data-mp="3c189c353o5yq">
            {MID_TITLE_1}
            <span className="mt-2 block text-champagne-light" data-id="element-201" data-mp="w89c4hvunntk">{MID_TITLE_2}</span>
          </h2>

          <ul className="mx-auto mt-6 flex max-w-md flex-wrap justify-center gap-2 lg:mx-0 lg:justify-start" data-id="element-202" data-mp="117dmhbuifrlh">
            {midHighlights.map(item => <li key={item} className="whitespace-nowrap border border-charcoal-600 px-3 py-1.5 text-[11px] font-medium uppercase tracking-[0.12em] text-ivory-200" data-id="element-203" data-mp="1ceagi31iadsj">
                {item}
              </li>)}
          </ul>

          <p className="mx-auto mt-6 max-w-md font-display text-lg italic leading-snug text-ivory-100 lg:mx-0" data-id="element-204" data-mp="yerd1njn3qmk">
            {MID_CLOSING}
          </p>
        </div>

        <div data-id="element-205" data-mp="oq9frgakk1no">
          <CroppedImage image={PURCHASE_MOCKUP} className="mx-auto w-full max-w-sm" data-id="element-206" data-mp="ophj0258jxvt" />

          <p className="mt-6 text-center text-[12px] uppercase tracking-[0.12em] text-muted" data-id="element-207" data-mp="ko61kjwimiyp">
            Regular price <span className="line-through" data-id="element-208" data-mp="fpurq96808gh">{pricing.regularPrice}</span>
          </p>
          <p className="mt-1 text-center font-display text-6xl font-semibold leading-none text-ivory-50" data-id="element-209" data-mp="apyoic5ckl1z">
            <span className="mr-2 align-middle font-sans text-[11px] font-semibold uppercase tracking-[0.16em] text-champagne" data-id="element-210" data-mp="5rex3w7zih28">
              Today
            </span>
            {pricing.today}
            <span className="ml-2 align-middle font-sans text-xs font-semibold uppercase tracking-[0.14em] text-muted" data-id="element-211" data-mp="12cmn9oqxbtj">
              USD
            </span>
          </p>

          <div className="mt-6 flex justify-center" data-id="element-212" data-mp="3jabuqx5f32p9">
            <CtaButton size="md" data-id="element-213" data-mp="3navp5sylvs7p" />
          </div>
          <TrustStrip className="mt-3" data-id="element-214" data-mp="3nbnkr3s7dpxz" />
        </div>
      </div>
    </section>;
}